import { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { SearchIcon } from '../../Icons';
import { PlansIcon } from 'pages/Radar/RadarKits/components';
import { Checkbox } from 'antd';

type KitsSequencesPropsType = {
  campaigns: any[];
  selectionChangeHandle: (ids: number[]) => void;
  selectedCampaigns: number[];
};

const KitsSequences = (props: KitsSequencesPropsType) => {
  const { campaigns, selectionChangeHandle, selectedCampaigns } = props;
  const [searchString, setSearchString] = useState<string>('');
  const [sequences, setSequences] = useState<any[]>([]);
  const [selectedSequences, setSelectedSequence] = useState<number[]>(selectedCampaigns || []);

  useEffect(() => {
    if (!campaigns?.length) return;

    if (!searchString) {
      setSequences(campaigns);
      return;
    }

    const filteredSequences = campaigns.filter((sequence) => {
      const { Name } = sequence;
      return Name?.toLowerCase().includes(searchString.toLowerCase());
    });
    setSequences(filteredSequences);
  }, [searchString]);

  useEffect(() => {
    selectionChangeHandle(selectedSequences);
  }, [selectedSequences]);

  return (
    <div className={styles.kitsSequences}>
      <div className={styles.heading}>Do you want to enroll this address in a KIT sequence?</div>
      <div className={styles.search}>
        <SearchIcon />
        <input
          type="text"
          placeholder="Search"
          className={styles.input}
          onChange={(e) => setSearchString(e.target.value)}
        />
      </div>
      {campaigns?.length ? (
        <div className={styles.sequences}>
          {sequences.map((seq) => (
            <div className={styles.sequence}>
              <div className={styles.left}>
                <PlansIcon />
              </div>
              <div className={styles.middle}>
                <div className={styles.name}>{seq.Name || '-'}</div>
                {seq.Description && <div className={styles.description}>{seq.Description}</div>}
              </div>
              <div className={styles.right}>
                <Checkbox
                  type="checkbox"
                  name="isPrimary"
                  className="mosaikCheckbox"
                  value={selectedSequences.includes(seq.Id)}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    if (isChecked) setSelectedSequence((prev) => [...prev, seq.Id]);
                    else setSelectedSequence((prev) => prev.filter((id) => id !== seq.Id));
                  }}
                  checked={selectedSequences.includes(seq.Id)}
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.empty}>No sequences available</div>
      )}
    </div>
  );
};

export default KitsSequences;
